import sound from "../sound.mp3";
class AudioServices {
    playAudio() {
        const audio = new Audio(sound)
        if(audio){
            audio.play()
        }
    }
}
export default new AudioServices();